import type { GetPromoterMeBindingResponse } from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

/**
 * Typed wrapper around platform-api `GET /v1/promoter/me/binding`.
 *
 * Binding is created through `POST /v1/billing/redeem` (promoter-code
 * arm). This GET is the read face for the org owner's bind state.
 * C-end responses never carry upstream identity. Callers must not add
 * any.
 */

const BASE_PATH = '/v1/promoter';

export async function getMyBinding(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<GetPromoterMeBindingResponse> {
  return platformApiRequest<GetPromoterMeBindingResponse>(
    `${BASE_PATH}/me/binding`,
    { signal },
    fetchImpl,
  );
}
